/* eslint-disable default-param-last */
// tags.reducers.js

import { FETCH_TAGS, FETCH_TAG } from '../types'

export function tags(state = [], action) {
  switch (action.type) {
    case FETCH_TAGS:
      return action.data
    default:
      return state
  }
}

export function tag(state = {}, action) {
  switch (action.type) {
    case FETCH_TAG:
      return action.data
    default:
      return state
  }
}
